/**
 * Eén kleurenkaart voor taken, over alle planningsschermen heen.
 *
 * Stonden 4× (prio) en 3× (type) lokaal gedefinieerd — nét verschillend: op de
 * Dagstart was Prio 2 oranje, op het taskboard rood; "Afspraak" was paars óf
 * grijs. Wie dezelfde taak op twee schermen ziet moet dezelfde kleur zien,
 * anders zegt de kleur niets meer. Gouden standaard: de tinten die Dagstart en
 * het Capaciteit-overzicht al deelden.
 */

export const PRIO_COLORS = {
  'Prio 1': '#ef4444',
  'Prio 2': '#f97316',
  'Prio 3': '#eab308',
  'Prio 4': '#22c55e',
  'Deadline': '#ef4444',
  'Afspraak': '#a855f7',
  'Draaidag': '#f97316',
  'Vrij/intern': '#64748b',
  'Vrije dag': '#64748b',
  'Vanallesuurtje': '#06b6d4',
  'Wacht op feedback': '#f59e0b',
  'Geen prio': '#9ca3af',
  'Nog niet van toepassing': '#d1d5db',
  'Intern': '#8b5cf6',
  'Afgerond': '#10b981',
  'Opgestuurd': '#8b5cf6',
};

export const TYPE_COLORS = {
  'Preproductie': '#3b82f6',
  'Montage': '#10b981',
  'Animatie': '#ec4899',
  'Illustratie': '#f59e0b',
  'Draaidag': '#f97316',
  'Afspraak': '#a855f7',
  'Intern': '#8b5cf6',
  'Deadline': '#ef4444',
  'Vrije dag': '#64748b',
  'Regie': '#7c3aed',
  'Script': '#06b6d4',
  'Sounddesign': '#0891b2',
  'Colorgrading': '#8b5cf6',
};

// Functienamen (Planner To-Do groepeert op functie) volgen de kleur van het
// werk dat die functie doet — Editor kleurt als Montage, enz.
export const FUNCTIE_COLORS = {
  'Editor': TYPE_COLORS['Montage'],
  'Animator': TYPE_COLORS['Animatie'],
  'Illustrator': TYPE_COLORS['Illustratie'],
};
